export const FIELD_IDS = {
  cardNumber: "sf-card-number",
  expiryMonth: "sf-expiry-month",
  expiryYear: "sf-expiry-year",
  securityCode: "sf-security-code",
  nameOnCard: "sf-cardholder-name",
} as const;

export const FIELD_SELECTORS = {
  number: `#${FIELD_IDS.cardNumber}`,
  expiryMonth: `#${FIELD_IDS.expiryMonth}`,
  expiryYear: `#${FIELD_IDS.expiryYear}`,
  securityCode: `#${FIELD_IDS.securityCode}`,
  nameOnCard: `#${FIELD_IDS.nameOnCard}`,
} as const;
